import { useSelector } from 'react-redux';

const useIsLoggedIn = () => {
  const isLoggedIn = useSelector(state => state.auth.loggedIn);
  return isLoggedIn;
};

export default useIsLoggedIn;
